import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import AuCard from "./AuCard";
import { useDispatch, useSelector } from "react-redux";
import { getAllSellItem, getItems } from "store/actions";
import { Oval } from 'react-loader-spinner'
export default function AuctionView(props) {
  const { AuctionData } = props;
  const location = useLocation();
  const dispatch = useDispatch()
  const { sellItems, loading } = useSelector((state) => state?.SellItems);
  const [nftAuctionData, setNftAuctionData] = useState([])
  const [fields, setFields] = useState({
    limit: 100000,
    order: -1,
    // fields: [{
    //   fieldName: "putOnSale",
    //   fieldValue: true
    // },
    //   {
    //     fieldName: "saleType",
    //     fieldValue: "auction"
    //   }
    // ]
  });
  useEffect(() => {
  }, [location, AuctionData]);
  useEffect(() => {
    dispatch(getAllSellItem(fields));
  }, [fields]);


  useEffect(() => {
    setNftAuctionData(
      sellItems.filter((item) => item?.sellType === "auction")
    )
  }, [sellItems]);
  return (
    <>
      {loading &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }
      <div className="position-relative">
        <Header />
        <div className="gradientBg">
          <div className="container-fluid profileBox dashboardprofile">
            <Row>
              <Col lg={12}>
                <h1>DIGITAL ARTWORK LIVE AUCTION</h1>
              </Col>
            </Row>
          </div>
        </div>
        <Container>
          {nftAuctionData?.length > 0 ?
            <Row className="py-5">
              {nftAuctionData?.map((nftData, idx) => {
                return (
                  <Col className="mb-5" md={6} lg={4} xl={3} key={idx}>
                    <AuCard data={nftData} />
                  </Col>
                );
              })}
            </Row> :
            <div className="text-center d-grid justify-content-center dataNotFound py-5">
              <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
              <h3>No Live Auction Found!!</h3>
            </div>
          }
        </Container>
        <Footer />
      </div>
    </>
  );
}
